/* ===========================================================================
   Ivitapure — gåvor i korgen (2026-09-30)

   Köpboxen på produktsidor med gåvor (assets/ivitapure-cpdp.js) lägger gåvorna
   i korgen tillsammans med varan, med två dolda egenskaper:
     _gift_for  produktens handle, t.ex. "crealyte"
     _gift_qty  antal av produkten som krävs, t.ex. "3"
   Rabatten "Gåva vid 90 dagar" i Shopify gör gåvorna gratis så länge korgen har
   produkten som prenumeration i minst det antalet.

   Det här skriptet städar när korgen ändras, så att en kund aldrig betalar för
   en gåva:
     - finns ingen sådan rad kvar tas gåvorna bort
     - ligger samma gåva flera gånger blir det en
   Laddas av snippets/cart-drawer.liquid och sections/main-cart-items.liquid.
   =========================================================================== */
(function () {
  if (window.__ipGifts) return;
  window.__ipGifts = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SOURCE = 'ivitapure-gifts';
  var busy = false;

  function qualifies(cart, handle, need) {
    return (cart.items || []).some(function (x) {
      return x.handle === handle && x.selling_plan_allocation && x.quantity >= need;
    });
  }

  function check() {
    if (busy || !window.fetch) return;
    busy = true;
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var updates = {};
        var changed = 0;
        var seen = {};
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (!p._gift_for) return;
          var need = parseInt(p._gift_qty || '1', 10) || 1;
          var want = qualifies(cart, p._gift_for, need) && !seen[it.variant_id] ? 1 : 0;
          if (want) seen[it.variant_id] = true;
          if (it.quantity !== want) { updates[it.key] = want; changed++; }
        });
        if (!changed) return;
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE });
          }
        });
      })
      .catch(function () { /* korgen får aldrig gå sönder av det här */ })
      .then(function () { busy = false; });
  }

  function start() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.source === SOURCE) return;
        setTimeout(check, 60);
      });
    }
    check();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
